import { SPARTAN_PRODUCT_TOP_NAV_TRACKING } from '@/app/lcv/components/sections/spartan/products/shared/top-navigation/tracking';

export const SPARTAN_PRODUCT_TOP_NAV_INTEREST_MODAL_ID =
  SPARTAN_PRODUCT_TOP_NAV_TRACKING.interestModal;

export const SPARTAN_PRODUCT_TOP_NAV_INTEREST_FORM_ID = 'product-register';

export const SPARTAN_PRODUCT_TOP_NAV_INTEREST_FORM_NAME =
  'สนใจรถอีซูซุ / ทดลองขับ';

/** Horizontal inset: 16px → md 40px → lg 48px */
export const SPARTAN_PRODUCT_TOP_NAV_INTEREST_MODAL_INLINE_PADDING =
  'px-4 md:px-10 lg:px-12';

export const SPARTAN_PRODUCT_TOP_NAV_INTEREST_MODAL_LABELS = {
  ariaLabel: 'สนใจรถ',
  close: 'Close',
  title: 'ข้อมูลการติดต่อ',
  successConfirm: 'ตกลง',
} as const;
